<template>
  <div class="keyboard-box df-w-fs">
    <div class="keyboard-item banselect f-xl" @click="contactValue(x)" v-for="(x,i) in 9" :key="i">{{x}}</div>
    <div class="keyboard-item banselect f-xl" @click="contactValue(0)" :class="{'w66p':showDoubleZero===undefined}">0</div>
    <div class="keyboard-item banselect f-xl" @click="contactValue('.')" v-if="priceModel!==undefined">.</div>
    <div class="keyboard-item banselect f-xl" @click="contactValue('00')" v-if="showDoubleZero!==undefined">00</div>
    <div class="keyboard-item banselect f-xl w66p" @click="contactValue('-')" v-if="showMinus!==undefined">-</div>
    <div
      class="keyboard-item banselect df-c-ct f-xl"
      :class="{'w100p':priceModel!==undefined&&showMinus===undefined}"
      @click="deleteValue"
      @touchstart="gotouchstart"
      @touchmove="gotouchmove"
      @touchend="gotouchend">
      <img src="@/assets/icons/keyboarddel.png" style="width:42px;height:24px;">  
    </div>
  </div>
</template>

<script>
/**
 * 自定义键盘
 * @description 简单自定义键盘组件
 * @tutorial https://blog.csdn.net/PrisonersDilemma
 * @property {String||Number} inputValue = 父组件需要修改的值
 *  @value 
 * @property {Boolean} showDoubleZero 是否显示00
 * @property {Boolean} priceModel 价格模式 是否显示小数点
 * @property {Boolean} showMinus 是否显示负号
 * @property {String||Number} decimalPlaces 小数点位数，如果开启了小数点，默认2位小数
 * @property {String||Number} maxLength 最大长度
 */
export default {
  name: 'Keyboard',
  props: {
    inputValue: {
      type: [String, Number],
    },
    showMinus: {},
    showDoubleZero: {},
    priceModel: {},
    decimalPlaces: {
      type: [String, Number],
      default: 2
    },
    maxLength: {
      type: [Number, String],
      default: Infinity
    },
  },
  data() {
    return {
      value: this.inputValue,
      timer: 0,
    }
  },
  watch: {
    inputValue(val) {
      // console.log(`%c已有的输入值:`, 'color: #00f;', val)
      this.value = val
    }
  },
  methods: {
    // 輸入
    contactValue(key) {
      // console.log(`%c输入的字符+已有的字符:`, 'color: #00f;', val, this.value)
      let newValue = String(this.value)
      let val = String(key)
      switch (newValue) {
        case '':
        case '0':
          switch (val) {
            case '00': this.priceModel === undefined ? newValue += val : newValue = '0'; break
            case '.': newValue = '0.'; break
            case '-': newValue = '-'; break
            default: this.priceModel === undefined ? newValue += val : newValue = val; break
          }
          break;
        case '-':
          switch (val) {
            case '00': this.priceModel === undefined ? newValue += val : newValue += '0'; break
            case '.': newValue += '0.'; break
            case '-': break;
            default: newValue += val; break
          }
          break;
        default:
          if (newValue.includes('.') && newValue.length - newValue.indexOf('.') > Number(this.decimalPlaces)) {
          } else {
            switch (val) {
              case '.': !newValue.includes('.') && (newValue += val); break
              case '-': break
              default: newValue += val; break
            }
          }
          break;
      }

      if (Number(this.maxLength) !== NaN) {
        newValue = newValue.substring(0, this.maxLength)
      }
      // console.log(newValue, newValue.length, newValue.indexOf('.'), Number(this.decimalPlaces))
      this.$emit('update:inputValue', newValue)
    },
    // 回退
    deleteValue() {
      // console.log(`%c回退`, 'color: #00f;', )
      let newValue = this.value
      newValue = newValue.substr(0, newValue.length - 1)
      this.$emit('update:inputValue', newValue)
    },
    // 清空
    clearValue() {
      // console.log(`%c清空`, 'color: #00f;', )
      this.$emit('update:inputValue', '')
    },
    // 長按
    gotouchstart(){
      // console.log(`%c長按开始`, 'color: #00f;', )
      clearTimeout(this.timer)
      this.timer = 0
      this.timer = setTimeout(() => {
        this.clearValue()
      }, 600)//这里设置定时
    },
    // 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend(){
      // console.log(`%c手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件`, 'color: #f00;', )
      clearTimeout(this.timer)
      if (this.timer != 0) {
        // console.log(this.timer)
      }
    },
    // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove(){
      // console.log(`%c如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按`, 'color: #f00;', )
      clearTimeout(this.timer)
      this.timer = 0
    },
  },
}
</script>

<style lang="scss" scoped>
.keyboard-box{
  width: calc(77px * 3 + 8px * 2 * 3);
  // height: 232px;
}
.keyboard-item{
  width: 77px;height: 58px;line-height: 58px;text-align: center;
  border: 1px solid #979797;box-sizing: border-box;margin: 8px;
  &.nopoint{width: 66.6667%;}
  &.w66p{width: calc(66.6667% - 8px * 2);}
  &.w100p{width: 100%;}
  &:active{background: #eee;}
}
</style>